// Cookie Policy Page
// Feature #144 - Legal placeholder pages

import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors mb-8"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Tilbage til forsiden
        </Link>

        {/* Header */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
          Cookie-politik
        </h1>

        {/* Coming soon notice */}
        <div className="bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800 rounded-lg p-6 mb-8">
          <p className="text-primary-800 dark:text-primary-200">
            Indhold kommer snart. Vi arbejder på at udarbejde en cookie-politik,
            der beskriver hvordan vi bruger cookies og lignende teknologier.
          </p>
        </div>

        {/* Placeholder content */}
        <div className="prose prose-gray dark:prose-invert max-w-none">
          <p className="text-gray-600 dark:text-gray-400">
            Denne side vil indeholde information om:
          </p>
          <ul className="text-gray-600 dark:text-gray-400 space-y-2 mt-4">
            <li>Hvad cookies er</li>
            <li>Hvilke cookies vi bruger</li>
            <li>Formålet med vores cookies</li>
            <li>Hvordan du kan administrere cookies</li>
            <li>Tredjepartscookies</li>
          </ul>
        </div>

        {/* Last updated */}
        <p className="text-sm text-gray-500 dark:text-gray-500 mt-12">
          Sidst opdateret: Kommer snart
        </p>
      </div>
    </div>
  );
};

export default CookiePolicy;
